// angular
// 	.module("HeroPRO")
// 	.controller("AchController", achController);

import _ from 'lodash';
import './ach.scss';

/* @ngInject */
export default function achController(OfficesFactory, $stateParams, UserData, HPRoles, $rootScope) {
    const vm = this;

    vm.bankName = '';
    vm.routingNumber = '';
    vm.accountNumber = '';
    vm.verifyAccountNumber = '';
    vm.mainLocationId = -1;

    vm.defaultAccountType = {
        key: '-- Select a Type --',
        BankAccountTypeId: -1,
    };

    // Flags
    vm.isAcctNumberConfirmed = false;
    vm.isEditAccountNumber = false;
    vm.displayCheck = false;
    vm.saving = false;

    // Errors
    vm.uploadErrorMessage = '';

    // Check
    vm.checkFileName = '';
    vm.voidedCheckTempFileKey = '';

    // Account Types
    vm.selectedAccountType = {};
    vm.accountTypes = [];

    // Payment Status
    vm.paymentStatuses = [];
    vm.currentStatusMessage = '';

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.onCancelClick = function () {
        resetUIState();
        vm.cancelClick();
    };

    vm.accountTypeClicked = function (type) {
        vm.selectedAccountType = type;
        console.log(type);
    };

    vm.uploadButtonClicked = function ($event) {
        $event.preventDefault();
    };

    vm.checkAccountNumber = function () {
        vm.isEditAccountNumber = true;
        vm.checkAccountNumberChange();
    };

    vm.checkAccountNumberChange = function () {
        if (vm.accountNumber === vm.achData.ACHAccountNumber && vm.editOfficeFinance.$valid) {
            vm.isAcctNumberConfirmed = false;
            vm.isEditAccountNumber = false;
        } else if (vm.accountNumber !== vm.verifyAccountNumber && (vm.verifyAccountNumber !== '' && vm.verifyAccountNumber !== undefined)) {
            vm.editOfficeFinance.txtAccountNumber.$setValidity('nomatch', false);
            if (vm.editOfficeFinance.txtVerifyAccountNumber !== undefined) {
                vm.editOfficeFinance.txtVerifyAccountNumber.$setValidity('nomatch', false);
            }
            vm.errorMessage = 'Account Numbers do not match';
            vm.isAcctNumberConfirmed = false;
        } else {
            vm.editOfficeFinance.txtAccountNumber.$setValidity('nomatch', true);
            if (vm.editOfficeFinance.txtVerifyAccountNumber !== undefined) {
                vm.editOfficeFinance.txtVerifyAccountNumber.$setValidity('nomatch', true);
            }
            vm.errorMessage = '';
            if (vm.accountNumber === vm.achData.ACHAccountNumber) {
                vm.isAcctNumberConfirmed = false;
                vm.isEditAccountNumber = false;
            } else if (vm.achData.ACHAccountNumber === vm.verifyAccountNumber && vm.editOfficeFinance.$valid) {
                vm.isAcctNumberConfirmed = true;
            }
        }

        if (vm.editOfficeFinance.$invalid) {
            vm.isAcctNumberConfirmed = false;
        }
    };

    vm.submitFinancing = function (isValid) {
    //		console.log(isValid);
        if (isValid) {
            vm.saving = true;
            const data = {
                ContractorLocationId: (vm.notificationView === true) ? vm.mainLocationId : $stateParams.accountId,
                LocationACH: {
                    ACHAccountNumber: vm.accountNumber,
                    ACHBank: vm.bankName,
                    ACHBankAccountTypeId: vm.selectedAccountType.BankAccountTypeId,
                    ACHRoutingNumber: vm.routingNumber,
                    VoidedCheckTempFileKey: vm.voidedCheckTempFileKey,
                    VoidedCheckFileName: vm.checkFileName,
                },
            };
            savePaymentInfo(data);
        }
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        if (vm.achData !== undefined && vm.achData !== null) {
            rebindData();
        }
        if (vm.notificationView === null || vm.notificationView === undefined) {
            vm.notificationView = false;
        }
        if (vm.notificationView === true) {
            UserData.getMainLocation().then((response) => {
                vm.mainLocationId = response[0].ContractorId;
            });
        }

        getPaymentStatuses();
    }

    function getPaymentStatuses() {
        OfficesFactory.getPaymentStatuses().then((response) => {
            vm.paymentStatuses = response;
            _.each(vm.paymentStatuses, (status) => {
                if (status.PaymentMethodStatusId === vm.achData.PaymentMethodStatusId) {
                    vm.achData.currentStatusMessage = status.Description;
                }
            });
            getAccountTypes();
        });
    }

    function getAccountTypes() {
        OfficesFactory.getAccountTypes().then((response) => {
            vm.accountTypes = response;
            if (vm.achData.ACHBankAccountTypeId !== undefined && vm.achData.ACHBankAccountTypeId !== null) {
                const currentAccountType = _.find(vm.accountTypes, type => type.BankAccountTypeId === vm.achData.ACHBankAccountTypeId);
                vm.selectedAccountType = currentAccountType;
            } else {
                vm.selectedAccountType = vm.accountTypes[0];
            }
        });
    }

    function rebindData() {
        vm.bankName = vm.achData.ACHBank;
        vm.routingNumber = vm.achData.ACHRoutingNumber;
        vm.accountNumber = vm.achData.ACHAccountNumber;
    }

    function resetUIState() {
        vm.verifyAccountNumber = '';
        vm.errorMessage = '';
        vm.isAcctNumberConfirmed = false;
        vm.isEditAccountNumber = false;
        vm.displayCheck = false;
        vm.checkFileName = '';
        vm.voidedCheckTempFileKey = '';
    }

    function savePaymentInfo(data) {
        OfficesFactory.saveFinanceInfo(data).then((response) => {
            vm.achData.ACHBank = response.data.Data.LocationACH.ACHBank;
            vm.achData.ACHRoutingNumber = response.data.Data.LocationACH.ACHRoutingNumber;
            vm.achData.ACHAccountNumber = response.data.Data.LocationACH.ACHAccountNumber;
            vm.achData.PaymentMethodStatusId = response.data.Data.LocationACH.PaymentMethodStatusId;
            _.each(vm.paymentStatuses, (status) => {
                if (status.PaymentMethodStatusId === response.data.Data.LocationACH.PaymentMethodStatusId) {
                    vm.achData.currentStatusMessage = status.Description;
                }
            });
            vm.achData.ACHBankAccountTypeId = response.data.Data.LocationACH.ACHBankAccountTypeId;
            const currentAccountType = _.find(vm.accountTypes, type => type.BankAccountTypeId === response.data.Data.LocationACH.ACHBankAccountTypeId);
            vm.selectedAccountType = currentAccountType;
            vm.saving = false;
            resetUIState();
            if (vm.saveClick !== undefined && vm.saveClick !== null) {
                vm.saveClick();
            }
        });
    }

    $rootScope.$on('HPFileUploaded', (event, args, file) => {
        vm.checkFileName = file.name;
        vm.voidedCheckTempFileKey = file.tempFileKey;
        $rootScope.$apply();
    });
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/financing/ach/achController.js